const CacheGroup = {
    candidates: "candidates",
    projects: "projects",
};
export default CacheGroup;